import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export interface Email {
  readonly senderName: string,
  readonly senderEmail: string,
  readonly subject: string,
  readonly message: string
}

export interface EmailState {
  readonly email: Email,
  readonly errorMessage: null | string

}


const initialState: EmailState = {} as EmailState;

export const sendEmail = createAsyncThunk<string, Email, { rejectValue: { readonly errorMessage: string } }>(
  'emails/send',

  async (arg, thunkAPI) => {

    return await fetch(
      '/api/emails/',
      {
          method: 'POST',
          body: JSON.stringify(arg),
          headers: {
            'Content-Type': 'application/json',
          },

      })

      .then(response => {
          if (response.status === 200) {
              return '' + response.body;
          } else {
              throw new Error(`Unexpected response from server (code ${response.status}).`);
          }
      })

      .catch(function (error) {
          console.error(error);
          return thunkAPI.rejectWithValue({ errorMessage: error.message });
      });
  }
);


export const emailSlice = createSlice({
    name: 'emailstate', // not sure what this 'name' is for. For the moment, I'll just call it the same as the reference in store.ts
    initialState,
    reducers: {
        resetState: () => initialState
    },
    extraReducers: (builder) => {
      builder
      .addCase(sendEmail.fulfilled, (state, action) => {
        state.errorMessage = null;
        state.email = {} as Email;
      })

    },
  
});

export const {resetState} = emailSlice.actions


export default emailSlice.reducer;